module.exports = __webpack_public_path__ + "img/3hr-09.745fda3f.jpg";